import { motion } from 'framer-motion';
import { PROCESS } from './data';

// PROCESS — vertical six-month timeline. Distinctive: alternating left/right per
// month with a champagne thread connecting them.
export default function Process({ setPage }) {
  return (
    <div className="bg-[#0B0A0E] text-white">
      <section className="pt-32 pb-12 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-white/10">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9B68B] mb-4">— Six months, the long way</p>
        <h1 className="font-serif text-[48px] lg:text-[112px] leading-[0.92] tracking-[-0.02em] max-w-5xl">A piece, <span className="italic text-[#C9B68B]">slowly</span>.</h1>
        <p className="font-serif italic text-lg lg:text-xl text-white/65 mt-6 max-w-2xl">No commission has ever taken less than five months. The longest, the bracelet on Specimens, took twenty-three.</p>
      </section>

      <section className="relative max-w-[1100px] mx-auto px-8 lg:px-14 py-20">
        {/* Champagne vertical line — desktop only */}
        <div className="absolute left-1/2 top-20 bottom-20 w-px bg-[#C9B68B]/30 hidden lg:block" />
        <div className="space-y-16 lg:space-y-32">
          {PROCESS.map((p, i) => (
            <motion.div key={p.m} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className={`relative grid lg:grid-cols-2 gap-12 ${i % 2 === 1 ? 'lg:[direction:rtl]' : ''}`}>
              <div className="lg:[direction:ltr] relative">
                <div className="hidden lg:block absolute -right-8 top-3 w-3 h-3 rotate-45 bg-[#C9B68B]" style={i % 2 === 1 ? { left: '-2rem', right: 'auto' } : {}} />
                <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9B68B]">{p.m}</p>
                <h2 className="font-serif text-3xl lg:text-5xl mt-2 leading-[1.05]">{p.t}</h2>
                <p className="text-base lg:text-lg text-white/65 mt-5 leading-[1.7] max-w-md" dangerouslySetInnerHTML={{ __html: p.d }} />
              </div>
              <div className="lg:[direction:ltr] aspect-[4/5] overflow-hidden bg-gradient-to-b from-[#15131A] to-[#0B0A0E] border border-[#C9B68B]/10 hidden lg:block">
                <img src={`https://images.pexels.com/photos/${[691046, 1454171, 177332, 1232931, 1191531, 1191710][i]}/pexels-photo-${[691046, 1454171, 177332, 1232931, 1191531, 1191710][i]}.jpeg?auto=compress&cs=tinysrgb&w=900`} alt="" className="w-full h-full object-cover opacity-80" loading="lazy" />
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="max-w-[820px] mx-auto px-8 lg:px-14 pb-24 text-center">
        <p className="font-serif text-3xl lg:text-5xl leading-[1.15]">If five months is too long, <span className="italic text-[#C9B68B]">we are not for you</span>. With kindness.</p>
        <button onClick={() => setPage('commission')} className="mt-10 bg-[#C9B68B] text-[#0B0A0E] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-white transition-colors">Begin a commission →</button>
      </section>
    </div>
  );
}
